module.exports = __webpack_public_path__ + "img/intro2.f362f1dc.png";